module.exports = __webpack_public_path__ + "media/images/pc/stores/kyoto/kyoto_concept_05-9bc9856367bd1bf80c7fa16bc4eac3af.jpg";